/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Hero_Stat_SinceInputs */

const en_hero_stat_since = /** @type {(inputs: Hero_Stat_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`since ${i?.year}`)
};

const pl_hero_stat_since = /** @type {(inputs: Hero_Stat_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`od ${i?.year}`)
};

/**
* | output |
* | --- |
* | "since {year}" |
*
* @param {Hero_Stat_SinceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_stat_since = /** @type {((inputs: Hero_Stat_SinceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Stat_SinceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_stat_since(inputs)
	return en_hero_stat_since(inputs)
});